module.exports = __webpack_public_path__ + "asset/image-upgrade-to-collaborate-7515ae14f2865789.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/team-edit-modal/image/upgrade-to-collaborate.svg
// module id = WdxZ
// module chunks = 0